import { cn } from '@nexelem/utils';
import { Avatar } from '@nexelem/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';

export type AvatarItem = {
  firstName?: string;
  lastName?: string;
};

type MultipleTableAvatarProps = {
  avatars: (AvatarItem | undefined)[];
  className?: string;
};

type NodeAvatarProps = {
  count?: number;
  firstName?: string;
  lastName?: string;
  className?: string;
};

const NodeAvatar = ({ className, count, ...props }: NodeAvatarProps) => {
  if (props.firstName && props.lastName && !count) {
    return <Avatar className={className} {...props} />;
  }

  return (
    <Avatar className={className} color="placeholder" {...props}>
      {count ? (
        <span className="text-s10-sb text-text-status-orange">+{count}</span>
      ) : (
        <FontAwesomeIcon className="h-3 w-3" icon={faUser} />
      )}
    </Avatar>
  );
};

const isSameNamedAvatar = (a: AvatarItem, b: AvatarItem) =>
  Boolean(a.firstName && a.lastName && a.firstName === b.firstName && a.lastName === b.lastName);

export const MultipleTableAvatar = ({ avatars, className }: MultipleTableAvatarProps) => {
  const uniqueAvatars = avatars.reduce<AvatarItem[]>((acc, avatar) => {
    const normalized = avatar ?? {};
    if (!acc.some((a) => isSameNamedAvatar(a, normalized))) {
      acc.push(normalized);
    }
    return acc;
  }, []);

  const [first, second] = uniqueAvatars;
  const count = uniqueAvatars.length > 2 ? uniqueAvatars.length - 1 : undefined;

  return (
    <div className={cn('flex', className)}>
      <NodeAvatar firstName={first?.firstName} lastName={first?.lastName} />
      {uniqueAvatars.length >= 2 && (
        <NodeAvatar className="-ml-1" count={count} firstName={second?.firstName} lastName={second?.lastName} />
      )}
    </div>
  );
};
